@if ({ availableInventories: availableInventoriesForCurrentDeliveryPeriod$ |
async, deliveryItems: deliveryItems$ | async, showAddNote: showAddNote$ | async,
selectedScale: selectedScale$ | async, selectedVariant: selectedVariant$ |
async, allDeliveryItems: allDeliveryItems$ | async, scaleSets: scaleSets$ |
async, prePacks: prepacks$ | async, advancedMdo: isAdvancedMdo$ | async, shops:
shops$ | async, titleAttributes: materialTitleAttributes$ | async, shopTotals:
shopTotals$ | async, differentMaterialDimensions: differentMaterialDimensions$ |
async }; as observables) { @if (observables.advancedMdo) {
<epc-advanced-pre-pack
  [shipTos]="observables.shops"
  [prePacks]="observables.prePacks"
  [selectedScale]="observables.selectedScale"
  [scaleSets]="observables.scaleSets"
  [deliveryItems]="observables.allDeliveryItems"
  [availableInventories]="observables.availableInventories"
  [showAddNote]="observables.showAddNote"
  [titleAttributes]="observables.titleAttributes"
  [shopTotals]="observables.shopTotals"
  [portable]="compactMdo"
  [differentMaterialDimensions]="observables.differentMaterialDimensions"
  [productImageMissingVisualConfig]="productImageMissingVisualConfig$ | async"
  (noteChanged)="onNoteChange($event.id, $event.note)"
  (clearShop)="clearShop($event)"
  (quantityChanged)="
    onQuantityChange($event.productId, $event.value, $event.shop)
  "
  (variantSelected)="selectVariant($event)"
  (copyQuantities)="copyQuantities($event)"
  (prepackSelected)="selectPrepack($event)"
  data-e2e="pre-pack-advanced-grid"
></epc-advanced-pre-pack>
} @if (!observables.advancedMdo) { @for ( prepack of observables.prePacks; track
trackByProductId($index, prepack); let first = $first) {
<epc-pre-pack
  [attr.data-e2e]="'pre-pack-item-container-' + prepack.productId"
  class="border-bottom pre-pack"
  [class.border-top]="first"
  [prepack]="prepack"
  [dabsData]="getDabsByPrepack(prepack.productId) | async"
  [scaleSets]="observables.scaleSets"
  [selectedScale]="observables.selectedScale"
  [selectedVariant]="observables.selectedVariant"
  [quantity]="
        observables.deliveryItems?.items?.[prepack.productId]?.quantity ?? 0
      "
  [note]="observables.deliveryItems?.items?.[prepack.productId]?.note ?? ''"
  [showAddNote]="observables.showAddNote"
  [differentMaterialDimensions]="observables.differentMaterialDimensions"
  (quantityChanged)="onQuantityChange(prepack.productId, $event)"
  (noteChanged)="onNoteChange(prepack.productId, $event)"
  (clickedMaterialImage)="selectVariant($event)"
  (prepackSelected)="selectPrepack($event)"
  [maxAvailableQuantity]="getMaxAvailableQuantity(prepack.productId) | async"
  [titleAttributes]="observables.titleAttributes"
  [productImageMissingVisualConfig]="productImageMissingVisualConfig$ | async"
></epc-pre-pack>
} } }
